import { createFragmentContainer, graphql } from 'react-relay';
import styled from 'styled-components';

import { useTranslation } from 'react-i18next';

import MaterialIcon from '../../common/icon/MaterialIcon';

import layout from '../../../app/layout';
import routeTo from '../../../router/utils/routeTo';
import { media } from '../../../utils/style';

import SidebarItem from './SidebarItem';

import { Sidebar_query } from './__generated__/Sidebar_query.graphql';

const Wrapper = styled.div`
  transition: all 500ms cubic-bezier(0.2, 1, 0.22, 1);
  position: absolute;
  flex-shrink: 0;
  top: -1px;
  bottom: -${layout.spacing};
  left: ${(props) =>
    props.visible
      ? `-${layout.spacing}`
      : `calc(-${layout.sidebar.width} - ${layout.spacing})`};
  display: flex;
  flex-direction: column;
  width: ${layout.sidebar.width};
  background: ${layout.sidebar.background};
  padding: ${layout.sidebar.padding};

  ${media.small`
    transition: none;
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
  `};
`;

const menuItems = (t: any) => {
  return [
    {
      icon: 'home',
      title: t('Home'),
      route: routeTo('dashboard.vacancies'),
    },
    {
      icon: 'search',
      title: t('Oportunities'),
      route: routeTo('dashboard.opportunities'),
    },
    {
      icon: 'work',
      title: t('My Resume'),
      route: routeTo('dashboard.professional.info'),
    },
    {
      icon: 'account_circle',
      title: t('My Profile'),
      route: routeTo('dashboard.account'),
    },
    {
      icon: 'folder',
      title: t('Documents'),
      route: routeTo('dashboard.documents'),
    },
    {
      icon: 'group',
      title: t('Dependents'),
      route: routeTo('dashboard.dependents'),
    },
    {
      icon: 'group_work',
      title: t('Group Dynamics'),
      route: routeTo('dashboard.groupInterviews'),
    },
    {
      icon: 'schedule',
      title: t('Interviews'),
      route: routeTo('dashboard.scheduledInterviews'),
    },
    {
      icon: 'message',
      title: t('Messages'),
      route: routeTo('dashboard.messages'),
    },
  ];
};

type Props = {
  visible: boolean;
  query: Sidebar_query;
};
const Sidebar = ({ visible }: Props) => {
  const { t } = useTranslation();
  const items = menuItems(t);

  return (
    <Wrapper visible={visible}>
      {items.map((item) => (
        <SidebarItem
          key={item.route}
          icon={
            <MaterialIcon fontSize={10} color="inherit">
              {item.icon}
            </MaterialIcon>
          }
          title={item.title}
          route={item.route}
        />
      ))}
      {/*<MobileSidebarItem
        icon={<MaterialIcon color='inherit'> group_work </MaterialIcon>}
        title={<FormattedMessage id='sidebar.groupInterviews' />}
        route={routeTo('dashboard.groupInterviews')}
      />*/}
    </Wrapper>
  );
};

export default createFragmentContainer(Sidebar, {
  query: graphql`
    fragment Sidebar_query on Query {
      me {
        totalDocumentsByStatus
      }
    }
  `,
});
